/* eslint-disable no-useless-escape */
const replaceAll = (s, strReplace, strWith) => {
  // See http://stackoverflow.com/a/3561711/556609
  var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  var reg = new RegExp(esc, "ig");
  return s.replace(reg, strWith);
};

const replaceAllMulti = (s, strList, strWith) => {
  if (!s) {
    return s;
  }
  if (strList?.length === 0) {
    return s;
  }
  for (var i = 0; i < strList.length; i++) {
    s = replaceAll(s, strList[i], strWith[i]);
  }

  return s;
};

export { replaceAll, replaceAllMulti };
